<template>
  <detail-layout ref="layout" :tableCfg="tableCfg">
    <template slot="FormLayout" scope="props">
      <b-form ref="form" class="col-md-6 offset-md-2" autocomplete="off">
        <div v-if="dataValid" >
          <detail-field label="Short Name" field="shortname" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field label="Name" field="name" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field label="Payment Holder Name" field="payment_holder_name" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field label="Payment Holder IBAN" field="payment_holder_iban" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field label="Payment Holder Swift" field="payment_holder_swift" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field label="Payment Holder Address" field="payment_holder_address" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field label="Payment Bank Address" field="payment_bank_address" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field label="Payment Amount" field="payment_amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
        </div>
      </b-form>
    </template>
  </detail-layout>
</template>

<script>
import DetailMixin from '../../components/DetailMixin'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'university_detail',
  mixins: [DetailMixin],
  data () {
    return {
      tableCfg: FieldDefs
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// Detail.vue?91fe35c4